import {
  PayeeRequirement,
  RequirementStatus
} from "@wingspanhq/wingspan-api-sdk";

import { RequirementAction } from "../types";

export const extendRequirementOnboardingToolbarActions = (
  requirement: PayeeRequirement,
  originalActions: RequirementAction[],
  onClose: () => void
): RequirementAction[] => {
  const isIncomplete =
    requirement.status === RequirementStatus.PENDING_COMPLETION;

  const defaultActions: RequirementAction[] = [
    {
      label: "Continue",
      buttonKind: "Primary",
      visible: !isIncomplete,
      hideButtonOn: [],
      onClick: () => {
        onClose();
      }
    },
    {
      label: "Close",
      buttonKind: "Tertiary",
      visible: isIncomplete,
      hideButtonOn: [],
      onClick: () => {
        onClose();
      }
    }
  ];

  if (
    originalActions.filter(
      action => action.visible !== false && action.hidden !== true
    ).length > 2
  ) {
    const visibleMainButtons = originalActions.map(action => ({
      ...action,
      buttonKind:
        action.mainAction && action.visible !== false && action.hidden !== true
          ? action.buttonKind
          : undefined
    }));

    return [...defaultActions, ...visibleMainButtons];
  }

  return [...defaultActions, ...originalActions];
};
